import React from "react";
import "../lifehacks/ArticleFull.css";

const SitioDoMorango = () => {
  return (
    <div className="article-full">
      <h2 className="article-subtitle">Sítio do Morango в Ранчо-Кеймадо: клубника, которую стоит попробовать</h2>
      <div className="article-section">
        <p className="article-text">
          В живописном уголке штата Санта-Катарина, в муниципалитете Ранчо-Кеймадо, спряталась настоящая клубничная ферма — 
          <a
            href="https://maps.app.goo.gl/link-to-sitio"
            target="_blank"
            rel="noopener noreferrer"
            className="article-link"
          > Sítio do Morango</a>. Здесь вы соберёте спелую клубнику своими руками, вдохнёте свежий воздух холмов и почувствуете себя частью уютной сельской жизни.
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">🍓 Уникальный опыт colha e pague</h3>
        <p className="article-text">
           Вооружитесь корзинкой и отправляйтесь на грядки за самой сочной клубникой! Формат <em>colha e pague</em> (собери и заплати) — это не только про ягоды, но и про радость от процесса. На выходе вашу корзинку взвесят, упакуют клубнику. Оплата (по состоянию на февраль 2025) — <b>30 реалов</b> за килограмм. Принимаются PIX и наличные. 
        </p>  
        <p className="article-text">
          На ферме также есть:
        </p>
        <ul className="article-list">
          <li>Бесплатный Wi-Fi</li>
          <li>Парковка</li>
          <li>Магазин с фермерскими продуктами (яйца, сыр, джемы, кашаса и многое другое)</li>
        </ul>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">🏡 Окрестности: немецкая деревенька и панорамные виды</h3>
        <p className="article-text">
          Поблизости от Sítio do Morango раскинулась очаровательная немецкая деревенька Taquaras, пропитанная европейским шармом. Здесь вы найдёте уютное 
          <a
            href="https://maps.app.goo.gl/Noj1SroLhici2qkG7?g_st=atm"
            target="_blank"
            rel="noopener noreferrer"
            className="article-link"
          > кафе</a> с домашней выпечкой и ароматным кофе — идеальное место для перерыва после клубничного приключения. 
          Не пропустите 
          <a
            href="https://maps.app.goo.gl/RyjXP9RSgLXwQ7Wk7?g_st=atm"
            target="_blank"
            rel="noopener noreferrer"
            className="article-link"
          > дом-музей Эрсилиу Луз</a>, где можно окунуться в историю региона и узнать о жизни выдающегося инженера и политика, сыгравшего ключевую роль в развитии штата Санта-Катарина. 
          А для любителей захватывающих видов недалеко от деревни открылась новая 
          <a
            href="https://maps.app.goo.gl/CzRi465scoD68a7Z9?g_st=atm"
            target="_blank"
            rel="noopener noreferrer"
            className="article-link"
          > стеклянная смотровая площадка</a>. С неё открывается панорама холмов и лесов Ранчо-Кеймадо, которая заставит ваше сердце биться быстрее!
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">📍 Как добраться</h3>
        <p className="article-text">
          Sítio do Morango расположен в районе Пинейрал (Pinheiral) муниципалитета Ранчо-Кеймадо, всего в 68 км от Флорианополиса. По шоссе BR-282 вы легко доберётесь до фермы, следуя указателям. Точное местоположение доступно на{" "}
          <a
            href="https://maps.app.goo.gl/eqnE7LZxQMRuBSdV8"
            target="_blank"
            rel="noopener noreferrer"
            className="article-link"
          >
            Google Maps
          </a>.
        </p>
      </div>
    </div>
  );
};

export default SitioDoMorango;
